import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./style.css";

const questions = [
  {
    option:
      "a) Parceiro desde diagnóstico até evolução do tratamento: garantindo acesso, oferecendo atendimento gratuito que auxilie na qualidade de vida, incentivando adesão e emponderando-o através de conhecimento.",
    correct: true,
  },
  {
    option: "b) Apenas com desconto aos pacientes",
    correct: false,
  },
  {
    option: "c) Apenas com de psicóloga e nutricionista",
    correct: false,
  },
  {
    option:
      "d) Apenas incentivando a adesão do paciente através de comunicação via WhatsApp",
    correct: false,
  },
];

export default function Question2(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question2: {
          title: "Como o Abraçar a Vida atua como ferramenta estratégica?",
          option: option.option,
          correct: option.correct,
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        Como o <span style={{ fontWeight: "bold" }}>Abraçar a Vida </span>atua
        como ferramenta estratégica?
      </h5>

      <div className="div-options-question-boe">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-boe ${
              optionSelected === e.option && "selected-option-question-boe"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
